import {Component, inject, Input, PLATFORM_ID, ChangeDetectionStrategy} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {isPlatformBrowser, NgClass} from '@angular/common';

@Component({
	selector: 'peps-lang-selector',
	imports: [
		NgClass
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './lang-selector.component.html',
})
export class LangSelectorComponent {

	constructor(
		protected readonly translate: TranslateService
	) {}

	@Input() items: { label: string; action: () => void; image?: string }[] = [];
	@Input() isMobileNavbar = false;

	private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

	isOpen = false;
	isMobile = false;

	select(action: () => void) {
		action();
		if(this.isMobile) {
			this.isOpen = false;
		}
	}

	ngOnInit() {
		if (!this.isBrowser) return;
		this.isMobile = window.innerWidth < 1024;
		window.addEventListener('resize', this.updateDeviceMode.bind(this));
	}

	ngOnDestroy() {
		if (!this.isBrowser) return;
		window.removeEventListener('resize', this.updateDeviceMode.bind(this));
	}

	updateDeviceMode() {
		this.isMobile = window.innerWidth < 1024;
		if (!this.isMobile) this.isOpen = false;
	}

	handleClick() {
		if (this.isMobile) this.isOpen = !this.isOpen;
	}
}
